<template>
  <page-wrapper title="Sap Mm Report">
    <div class="page-container">
      <div class="row" style="padding-left: 35px">
        <div class="query-box">
          <div class="label col-5">วันที่ส่งไป SAP</div>
          <date-picker v-model="sentToSapDate" type="daterange"></date-picker>
        </div>
        <div class="query-box">
          <div class="label col-12">วันที่ในใบเสร็จรับเงิน</div>
          <date-picker
            v-model="receiptDateRange"
            type="daterange"
          ></date-picker>
        </div>
        <div class="query-box">
          <div class="label col-12">วันที่ในใบกำกับภาษี</div>
          <date-picker v-model="taxInvoiceDate" type="daterange"></date-picker>
        </div>
        <div class="query-box">
          <div class="label col-12">เลขที่ใบเสร็จรับเงิน</div>
          <el-input type="text" v-model="query.documentNumber"></el-input>
        </div>
        <div class="query-box">
          <div class="label col-12">ข้อมูลที่ต้องการแสดง</div>
          <el-select v-model="query.status" clearable>
            <el-option
              v-for="t in filterSapStatus"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="mb-2 text-right">
        <sc-button variant="warning" @click="handleClickClear">clear</sc-button>
      </div>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
      <div class="report-container">
        <div class="csv">
          <button variant="secondary" @click.prevent="handleClickDownloadAsCSV">
            Download
          </button>
        </div>
        <div class="report">
          <div
            class="mm-report-row"
            :class="{ header: index === 0 }"
            v-for="(mmReport, index) in sapMmReportPresenters"
            :key="index"
          >
            <div class="report-cell receipt-link">
              <router-link
                target="_blank"
                v-if="mmReport.receipt_id"
                :to="{
                  name: 'ReceiptDetailPage',
                  params: { id: mmReport.receipt_id },
                }"
                >กดเพื่อดูใบเสร็จ</router-link
              >
            </div>
            <div class="report-cell">
              <router-link
                target="_blank"
                v-if="mmReport.appointment_id"
                :to="{
                  name: 'AppointmentDetailPage',
                  params: { id: mmReport.appointment_id },
                }"
                >กดเพื่อดูนัดหมาย</router-link
              >
            </div>
            <div class="report-cell">
              {{ mmReport.po_date }}
            </div>
            <div class="report-cell">
              {{ mmReport.rec_no }}
            </div>
            <div class="report-cell">
              {{ mmReport.tax_id }}
            </div>
            <div class="report-cell">
              {{ mmReport.type }}
            </div>
            <div class="report-cell">
              {{ mmReport.vendor_nam }}
            </div>
            <div class="report-cell">
              {{ mmReport.mat_number }}
            </div>
            <div class="report-cell">
              {{ mmReport.ser_nam }}
            </div>
            <div class="report-cell">
              {{ mmReport.quan }}
            </div>
            <div class="report-cell">
              {{ mmReport.unit }}
            </div>
            <div class="report-cell">
              {{ mmReport.price }}
            </div>
            <div class="report-cell">
              {{ mmReport.plant }}
            </div>
            <div class="report-cell">
              {{ mmReport.tax_code }}
            </div>
            <div class="report-cell">
              {{ mmReport.val_type }}
            </div>
            <div class="report-cell">
              {{ mmReport.inf_type }}
            </div>
            <div class="report-cell">
              {{ mmReport.submit_err_msg }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import { Select, Option, Input } from "element-ui";
import ProjectSelect from "@/lib/components/ProjectSelect";

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    ProjectSelect,
  },
  data() {
    const filterSapStatus = [
      { label: "ข้อมูลทั้งหมด", value: "" },
      { label: "ข้อมูล Success บน SAP", value: "successOnSap" },
      { label: "ข้อมูล Error บน SAP", value: "failOnSap" },
    ];

    return {
      sapMmReports: [],
      receiptDateRange: [],
      filterSapStatus,
      query: [],
      sentToSapDate: [],
      taxInvoiceDate: [],
    };
  },
  computed: {
    sapMmReportPresenters() {
      const header = {
        appointment_id: "นัดหมาย",
        receipt_id: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
        po_date: "วันที่ปิดงาน",
        rec_no: "เลขที่ใบเสร็จได้",
        tax_id: "Tax ID",
        type: "ประเภทของ Vender",
        vendor_nam: "ชื่อ Vender",
        mat_number: "MAT Number",
        ser_nam: "บริการ",
        quan: "จำนวน",
        unit: "หน่วย",
        price: "ราคา",
        plant: "Plant",
        tax_code: "Tax",
        val_type: "Valuation Type",
        inf_type: "Interface Type",
        submit_err_msg: "Error Message",
      };

      return [header, ...this.sapMmReports];
    },
    queryParams() {
      const {
        receiptDateFrom,
        receiptDateTo,
        status,
        documentNumber,
        sentToSapDateFrom,
        sentToSapDateTo,
        taxInvoiceDateFrom,
        taxInvoiceDateTo,
      } = this.$route.query;

      return {
        receiptDateFrom,
        receiptDateTo,
        status,
        documentNumber,
        sentToSapDateFrom: sentToSapDateFrom || "",
        sentToSapDateTo: sentToSapDateTo || "",
        taxInvoiceDateFrom: taxInvoiceDateFrom || "",
        taxInvoiceDateTo: taxInvoiceDateTo || "",
      };
    },
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setupData();
    },
    // receiptDateRange(newValue, oldValue) {
    //   if (!newValue) {
    //     return;
    //   }

    //   const [receiptDateFrom, receiptDateTo] = newValue;

    //   if (receiptDateTo.minus({ days: 31 }) > receiptDateFrom) {
    //     alert("ไม่สามารถเลือกเกิน 31 วันได้");
    //     this.receiptDateRange = oldValue;
    //   }
    // },
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const {
        receiptDateFrom,
        receiptDateTo,
        sentToSapDateFrom,
        sentToSapDateTo,
        taxInvoiceDateFrom,
        taxInvoiceDateTo,
      } = this.$route.query;

      this.query = {
        status: this.$route.query.status || null,
        documentNumber: this.$route.query.documentNumber || null,
      };

      if (receiptDateFrom && receiptDateTo) {
        this.receiptDateRange = [
          DateTime.fromISO(receiptDateFrom),
          DateTime.fromISO(receiptDateTo),
        ];
      }

      if (sentToSapDateFrom && sentToSapDateTo) {
        this.sentToSapDate = [
          DateTime.fromISO(sentToSapDateFrom),
          DateTime.fromISO(sentToSapDateTo),
        ];
      }

      if (taxInvoiceDateFrom && taxInvoiceDateTo) {
        this.taxInvoiceDate = [
          DateTime.fromISO(taxInvoiceDateFrom),
          DateTime.fromISO(taxInvoiceDateTo),
        ];
      }
    },
    setupData() {
      this.setupSapMmReports();
    },
    async setupSapMmReports() {
      this.sapMmReports = await this.fetchSapMmReports();
    },
    async fetchSapMmReports() {
      const response = await baanRueJaiClient.admin.sap.getSapMmReportList(
        this.queryParams
      );

      return response.data.result;
    },
    handleClickSearch() {
      let receiptDateFrom;
      let receiptDateTo;
      if (this.receiptDateRange && this.receiptDateRange.length > 1) {
        receiptDateFrom = this.receiptDateRange[0].toISO();
        receiptDateTo = this.receiptDateRange[1].toISO();
      }

      let sentToSapDateFrom;
      let sentToSapDateTo;
      if (this.sentToSapDate && this.sentToSapDate.length > 1) {
        sentToSapDateFrom = this.sentToSapDate[0].toISO();
        sentToSapDateTo = this.sentToSapDate[1].toISO();
      }

      let taxInvoiceDateFrom;
      let taxInvoiceDateTo;
      if (this.taxInvoiceDate && this.taxInvoiceDate.length > 1) {
        taxInvoiceDateFrom = this.taxInvoiceDate[0].toISO();
        taxInvoiceDateTo = this.taxInvoiceDate[1].toISO();
      }

      const query = {
        receiptDateFrom,
        receiptDateTo,
        status: this.query.status,
        documentNumber: this.query.documentNumber,
        sentToSapDateFrom,
        sentToSapDateTo,
        taxInvoiceDateFrom,
        taxInvoiceDateTo,
      };

      this.$router.push({ query });
    },
    async handleClickDownloadAsCSV(event) {
      event.preventDefault();
      const response = await baanRueJaiClient.admin.sap.getSapMmReportList({
        ...this.queryParams,
        format: "xlsx",
      });

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `sap-mm-reports.xlsx`;
      link.click();
    },
    handleClickClear() {
      this.query.status = "";
      this.receiptDateRange = "";
      this.query.documentNumber = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.report-container {
  padding: 20px 0;
  width: 100%;
}

.mm-report-row {
  display: grid;
  grid-template-columns:
    200px
    150px
    150px
    200px
    180px
    220px
    350px
    180px
    500px
    150px
    150px
    180px
    300px
    200px
    180px
    150px
    600px;
}

.mm-report-row:first-child {
  position: sticky;
  top: 0;

  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  padding: 10px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);
}

.report {
  padding: 15px;
}

.query-box {
  padding-right: 10px;
  padding-bottom: 10px;
  padding-top: 15px;
}

.csv {
  padding-left: 14px;
}

.receipt-link {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/features/sap/pages/SapMmReport.vue